import {
  HOME_PAGE_URL,
  CONTACT_PAGE_URL,
  SESSIONS_PAGE_URL,
  GALLERY_PAGE_URL,
  TRIBUTE_PAGE_URL,
  DUNGEON_PAGE_URL,
  FAQ_PAGE_URL,
  ABOUT_PAGE_URL,
  ADMIN_CONTACT_FORM_PAGE_URL,
} from '../Routes';

export const getNavLinkItemsArray = (user) => [
  { path: HOME_PAGE_URL, label: 'Home' },
  { path: ABOUT_PAGE_URL, label: 'About' },
  { path: SESSIONS_PAGE_URL, label: 'Services' },
  { path: GALLERY_PAGE_URL, label: 'Gallery' },
  // { path: DUNGEON_PAGE_URL, label: 'Dungeon' },
  { path: TRIBUTE_PAGE_URL, label: 'Links' },
  { path: FAQ_PAGE_URL, label: 'FAQ' },
  { path: CONTACT_PAGE_URL, label: 'Contact' },
  ...(user?.email
    ? user.role === 'ADMIN' || user.role === 'DEVELOPER'
      ? [
          { path: ADMIN_CONTACT_FORM_PAGE_URL, label: 'Admin' },
        ]
      : []
    : [
      ]),
];
